module.exports = __webpack_public_path__ + "img/tutela-del-clima-01.fb4ff6bb.svg";